import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IOTP } from '../OTP';

export function useActivateOTP(patientId?: number) {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<IOTP, AppMedError, { id: number; patientAcknowledged: boolean; patientAcknowledgmentNote?: string }>({
        mutationKey: [QueryKeys.otp, 'activate'],
        mutationFn: async ({ id, patientAcknowledged, patientAcknowledgmentNote }) => {
            return await OTPApi.activateOTP(id, patientAcknowledged, patientAcknowledgmentNote);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.otp] });
            if (patientId)
                queryClient.invalidateQueries({ queryKey: [QueryKeys.otpByPatient, patientId] });

            notifications.show({
                title: t('otp.notifications.activateSuccess.title'),
                message: t('otp.notifications.activateSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('otp.notifications.activateError.title'),
                message: error?.message || t('otp.notifications.activateError.message'),
                color: 'red',
            });
        },
    });
}
